import React from 'react';
import { ResponsiveContainer, AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, Legend } from 'recharts';
import { useTheme } from '../../theme/ThemeContext';

function CustomTooltip({ active, payload, label }) {
  if (!active || !payload?.length) return null;
  return (
    <div style={{
      background: 'var(--bg-card)', border: '1px solid var(--border)',
      borderRadius: 10, padding: '10px 14px', backdropFilter: 'blur(8px)',
      boxShadow: 'var(--shadow-md)',
    }}>
      <div style={{ color: 'var(--text-muted)', fontSize: 11, marginBottom: 6, fontWeight: 600 }}>{label}</div>
      {payload.map((p, i) => (
        <div key={i} style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 13, marginBottom: 2 }}>
          <span style={{ width: 8, height: 8, borderRadius: '50%', background: p.color, flexShrink: 0 }} />
          <span style={{ color: 'var(--text-secondary)' }}>{p.name}:</span>
          <span style={{ color: 'var(--text-primary)', fontWeight: 600, fontVariantNumeric: 'tabular-nums' }}>
            {typeof p.value === 'number' ? p.value.toLocaleString('ru-RU') : p.value}
          </span>
        </div>
      ))}
    </div>
  );
}

export default function TimeSeriesChart({
  data,
  lines = [{ key: 'revenue', name: 'Выручка', color: 'var(--accent)' }],
  height = 300,
  idPrefix = 'ts',
}) {
  const { theme } = useTheme();
  if (!data || data.length === 0) {
    return <div style={{ color: 'var(--text-muted)', padding: 40, textAlign: 'center', fontSize: 13 }}>Нет данных для графика</div>;
  }
  return (
    <ResponsiveContainer width="100%" height={height}>
      <AreaChart data={data} margin={{ top: 8, right: 20, left: 0, bottom: 0 }}>
        <defs>
          {lines.map((l, i) => (
            <linearGradient key={i} id={`${idPrefix}_grad_${i}`} x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor={l.color || theme.chartColors[i]} stopOpacity={0.25} />
              <stop offset="100%" stopColor={l.color || theme.chartColors[i]} stopOpacity={0.02} />
            </linearGradient>
          ))}
        </defs>
        <CartesianGrid strokeDasharray="3 3" stroke="var(--border)" vertical={false} />
        <XAxis dataKey="date" tick={{ fill: 'var(--text-muted)', fontSize: 11 }} tickLine={false} axisLine={{ stroke: 'var(--border)' }} />
        <YAxis tick={{ fill: 'var(--text-muted)', fontSize: 11 }} tickLine={false} axisLine={false}
          tickFormatter={(v) => v >= 1000000 ? `${(v / 1000000).toFixed(1)}M` : v >= 1000 ? `${(v / 1000).toFixed(0)}K` : v} />
        <Tooltip content={<CustomTooltip />} />
        <Legend wrapperStyle={{ color: 'var(--text-secondary)', fontSize: 12, paddingTop: 8 }} />
        {lines.map((l, i) => (
          <Area key={i} type="monotone" dataKey={l.key} name={l.name}
            stroke={l.color || theme.chartColors[i]} fill={`url(#${idPrefix}_grad_${i})`}
            strokeWidth={2.5} dot={false} activeDot={{ r: 5, strokeWidth: 2, fill: 'var(--bg-card)' }} />
        ))}
      </AreaChart>
    </ResponsiveContainer>
  );
}
